export default {
	"item.ATotalOf12MonthsAOneTimePurchaseOfTheAnnualReadingPlanWithNoFollowUpFees": "共计12个月，一次性购买全年阅读计划，没有后续费用",
	"item.SubscribeToTheProductDetailPageYourself": "自主订阅商品详情页",
	"item.SelfSubscribedProductDetailPageBUYButton": "自自主订阅商品详情页_购买按钮",
	"item.TheNameOfThePaymentMethodSelected": "选中的支付方式名称",
	"item.YouExistForAnActivatedCourse": "您存在已激活课程",
	"item.SorryTheVerificationFailed": "抱歉，验证未通过!",
	"item.MostRecentIssueStartDate": "最近一期开始日期：",
	"item.month": "月",
	"item.day": "日",
	"item.ConsecutiveSeasons": "连续包季",
	"item.quarter": "/季",
	"item.50OffPerSeason": "每季优惠50",
	"item.YearRoundPurchases": "全年购买",
	"item.500OffForTheWholeYear": "全年优惠500",
	"item.BuyNow": "立即购买"
}